import { IListSort, TGroupedInitiativeRow } from '../models'

import { LIST_STATUS_ORDER } from './getGroupedInitiativeRows'
import { EMPTY_LIST_VALUE } from './listDictionaries'
import { compareListPeriods } from './listPeriod'

export const sortInitiativeListRows = (
  rows: TGroupedInitiativeRow[],
  sort: IListSort,
  translate: (value: string) => string = (value) => value
): TGroupedInitiativeRow[] => {
  const compare = (left: TGroupedInitiativeRow, right: TGroupedInitiativeRow) => {
    let result = 0
    if (sort.field === 'finGoal') {
      if (left.finGoal == null) return right.finGoal == null ? 0 : 1
      if (right.finGoal == null) return -1
      result = left.finGoal - right.finGoal
    } else if (sort.field === 'Period') result = compareListPeriods(left.Period, right.Period)
    else if (sort.field === 'Status') {
      const index = (value?: string | null) => {
        const found = LIST_STATUS_ORDER.indexOf(value ?? EMPTY_LIST_VALUE)
        return found < 0 ? LIST_STATUS_ORDER.length : found
      }
      result = index(left.Status) - index(right.Status)
    } else {
      const value = (row: TGroupedInitiativeRow) =>
        sort.field === 'BusinessPriorities'
          ? (row.businessPriorityNames?.map(translate).join(', ') ?? '')
          : translate(String(row[sort.field] ?? ''))
      result = value(left).localeCompare(value(right), undefined, {
        numeric: true,
        sensitivity: 'base',
      })
    }
    result ||= translate(left.Name ?? '').localeCompare(translate(right.Name ?? ''), undefined, {
      numeric: true,
      sensitivity: 'base',
    })
    result ||= (left.EntryId ?? 0) - (right.EntryId ?? 0)
    return sort.direction === 'descending' ? -result : result
  }
  const result: TGroupedInitiativeRow[] = []
  let groupRows: TGroupedInitiativeRow[] = []
  const flush = () => {
    result.push(...groupRows.sort(compare))
    groupRows = []
  }
  rows.forEach((row) => {
    if (row.isGroupRow) {
      flush()
      result.push(row)
    } else groupRows.push(row)
  })
  flush()
  return result
}
